var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsegrey4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#9A8C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsegrey4);
export default __webpack_public_path__ + "static/media/Ellipsegrey4.432737ea76c382bf75f559889080f50e.svg";
export { ForwardRef as ReactComponent };